import {
    API_URL,
    CASINOGO_REST_API,
    CONTENT_SERVICE_API,
    GAME_LAUNCH_API,
} from 'configs/rest'
import { BehaviorSubject, combineLatest } from 'rxjs'
import {
    detectIpad,
    detectMobile,
    getPlatformForApi,
} from 'common/adapters/DeviceDetectAdapter'
import { get, post } from 'common/adapters/FetchAdapter'
import NotificationConductor from 'common/conductors/NotificationConductor'
import { startGame } from 'services/GameLaunchService'
import { ModalService } from 'services/ModalService'
import axios from 'axios'
import getTexts from 'utils/localization'
import { getEnv, getEnvWithBeta } from 'utils/env'
import UserService from 'services/UserService'
import { setCookie } from 'services/CookieService'
import { APP_NAME, MAX_MULTI_GAMES_COUNT } from 'configs/main'
import CmsREST from 'features/CMSAPI'
import { sortingByHotClicks } from 'utils/sorting'
import { providersData } from 'configs/ui'
import { formatDenmarkCurrent } from 'utils/ui'
import { map } from 'rxjs/operators'

const t = getTexts()

let intervalLiveCasino = null
let intervalLiveCasinoStopTimeout = null

const allGames = new BehaviorSubject([])
const categorizedGames = new BehaviorSubject([])
const liveCasinoGames = new BehaviorSubject({})
const liveCasinoData = new BehaviorSubject([])
const gamesConfig = new BehaviorSubject(null)
const multipleGames = new BehaviorSubject([])
const newGames = new BehaviorSubject([])
const hiddenGames = new BehaviorSubject([])
const bonusGames = new BehaviorSubject([])
const jackpotGames = new BehaviorSubject([])
const recentlyPlayedGames = new BehaviorSubject([])
const isGameLaunched = new BehaviorSubject(false)
const favoriteGames = new BehaviorSubject([])
const providersGames = new BehaviorSubject(null)
const GamesStatus = new BehaviorSubject({
    pending: false,
    success: false,
    error: '',
})
const gamesCategories = new BehaviorSubject([])
const minimizedGamesData = new BehaviorSubject({})
const endGameUrl = new BehaviorSubject('')
const recommendedGames = new BehaviorSubject([])

const fetchGames = (
    endpoint,
    data = {
        platform: getPlatformForApi(),
        srv: getEnv(),
    }
) => {
    if (!data.platform) {
        data.platform = getPlatformForApi()
        data.srv = getEnv()
    }
    return get(CASINOGO_REST_API + 'games' + endpoint, data)
}
const gameLike = (game_id) => {
    const user_id = localStorage.getItem('userId')
    if (!user_id) {
        return Promise.reject(new Error(t.LOGINFIRST))
    }
    return axios.post(`${CASINOGO_REST_API}clients/${user_id}/games/${game_id}`)
}
const gameUnLike = (game_id) => {
    const user_id = localStorage.getItem('userId')
    if (!user_id) {
        return Promise.reject(new Error(t.LOGINFIRST))
    }
    return axios.delete(
        `${CASINOGO_REST_API}clients/${user_id}/games/${game_id}`
    )
}
const getLaunchLink = (options) => {
    let requestParams = {
        ...options,
        platform: getPlatformForApi(),
        lobby:
            detectMobile() && !detectIpad()
                ? window.location.origin
                : window.location.origin + '/lobby',
    }

    if (!detectMobile() || detectIpad()) {
        requestParams.platform = 'web'
    }

    return post(GAME_LAUNCH_API + '/games/launch/casinogo', requestParams)
        .then((res) => {
            if (res.error) {
                console.log(res.error)
                NotificationConductor.error(
                    'Din session er udløbet, log venligst ind igen.'
                )
            }

            if (res.data) {
                let link = res.data.url
                if (res.data.meta && res.data.meta.endgame) {
                    endGameUrl.next(res.data.meta.endgame)
                }
                if (res.data.params && res.data.params['set-cookie']) {
                    let netentCookie =
                        res.data.params['set-cookie']
                            .replace('NetEnt=', '')
                            .replace('; path=/; Secure', '') +
                        ';.domain=casinogo-static.casinomodule.com'

                    setCookie('NetEnt', netentCookie)
                }
                return link
            }
        })
        .catch((error) => {
            console.log(error)
            NotificationConductor.error(
                'Din session er udløbet, log venligst ind igen.'
            )
        })
}
const getGameLaunchUrl = (options) => {
    if (options.mode === 'fun') {
        return getLaunchLink({
            ...options,
        })
    }

    return post('/getSes.php')
        .then((data) => {
            return getLaunchLink({
                ...options,
                session_id: 'JSESSIONID=' + data.sessId,
            })
        })
        .catch((err) => {
            console.log(err)
            NotificationConductor.error(
                'Din session er udløbet, log venligst ind igen.'
            )
        })
}
const checkLoginBeforeStart = (game, history, mode, logged) => {
    UserService.checkUserLogin().then(({ login }) => {
        const showSessionPopup = !login && logged
        if (!showSessionPopup) {
            if (login || mode === 'fun') {
                LaunchGame(game, history, mode)
            } else {
                // Store game information before redirecting to login
                localStorage.setItem(
                    'pendingGame',
                    JSON.stringify({
                        game: game,
                        mode: mode,
                    })
                )
                UserService.openLoginModal()
            }
        }
    })
}
const LaunchGame = (game, history, mode = 'fun') => {
    if (game.game_id) {
        if (detectMobile() && !detectIpad()) {
            startGame(
                game,
                (link) => {
                    if (link.includes('playngonetwork')) {
                        ModalService.showModal('GAME_MODAL', {
                            link,
                        })
                        window.history.pushState(
                            {},
                            '',
                            `/spil/${game.game_id}/${mode}`
                        )
                    } else {
                        window.location.href = link

                        setTimeout(() => {
                            ModalService.closeModal()
                        }, 1000)
                    }
                },
                mode
            )
        } else {
            history.push(`/spil/${game.game_id}/${mode}`)
        }
    }
}

const launchPendingGame = (history, fallbackAction = () => {}) => {
    const pendingGameStr = localStorage.getItem('pendingGame')
    if (pendingGameStr) {
        try {
            const pendingGame = JSON.parse(pendingGameStr)
            // Clear the pending game from localStorage
            localStorage.removeItem('pendingGame')

            // Launch the game
            LaunchGame(pendingGame.game, history, pendingGame.mode)
            return true
        } catch (error) {
            console.error('Error parsing pending game:', error)
            fallbackAction()
            return false
        }
    }
    fallbackAction()
    return false
}
const setGamesByEndpoint = (endpoint, data) => {
    switch (endpoint) {
        case 'new':
            newGames.next(data)
            break
        case 'hidden':
            hiddenGames.next(data)
            break
        case 'bonus':
            bonusGames.next(data)
            break
        case 'jackpot':
            jackpotGames.next(data)
            break
        default:
            allGames.next(data)
    }
}
const getIterationLength = (type) => {
    let length = 20

    if (detectMobile()) {
        length = 10
    } else if (type === 'dynamic') {
        length = 14
    } else if (type === 'small') {
        length = 30
    }
    return length
}
const sortGames = (allGames, setAllGames, setGames, method, reversed) => {
    let games = []
    if (method === 'name') {
        games = allGames.sort((a, b) => a.name.localeCompare(b.name))
    } else if (method === 'new') {
        games = allGames.sort((a, b) => {
            return (
                a.go_new - b.go_new ||
                parseFloat(a.go_priority) - parseFloat(b.go_priority) ||
                a.name.localeCompare(b.name)
            )
        })
    } else if (method === 'popular') {
        games = sortingByHotClicks(allGames)
    } else if (method === 'minStake') {
        games = allGames.sort(
            (a, b) =>
                parseFloat(b.min_stake || 0) - parseFloat(a.min_stake || 0) ||
                a.name.localeCompare(b.name)
        )
    } else if (method === 'tbp') {
        allGames.map((game) => {
            if (!game.payback) game.payback = '0'
            return game
        })
        games = allGames.sort(
            (a, b) =>
                parseFloat(b.payback.replace('%', '')) -
                    parseFloat(a.payback.replace('%', '')) ||
                a.name.localeCompare(b.name)
        )
    } else if (method === 'jackpot') {
        allGames.map((game) => {
            if (game.jackpot_amount === null) {
                game.jackpot_amount = -1
            }
            return game
        })
        games = allGames.sort((a, b) => {
            return (
                parseFloat(b.jackpot_amount) - parseFloat(a.jackpot_amount) ||
                a.name.localeCompare(b.name)
            )
        })
    } else {
        games = allGames
    }
    if (reversed === 'true') {
        games = games.reverse()
    }
    setAllGames(games)
    setGames(games.slice(0, getIterationLength()))
}

const getMultipleGameFromTheStore = (game) => {
    const prevValue = multipleGames.value

    if (prevValue.length < MAX_MULTI_GAMES_COUNT) {
        return [...prevValue, game]
    }
}

const updateMultipleGameInTheStore = (key, game) => {
    const prevValue = multipleGames.value

    if (prevValue.length) {
        prevValue[key] = game
        return [...prevValue]
    }
}

const removeMultipleGameFromTheStore = (key = null) => {
    const multipleGamesStore = [...multipleGames.value]

    if (key === null) {
        return []
    } else if (multipleGamesStore.length > 1) {
        multipleGamesStore.splice(key, 1)

        return [...multipleGamesStore]
    }
}

const mapRecentGames = (recentGames) => {
    return recentGames.map((data) => ({ ...data.game }))
}

const setRecentGames = (userId) => {
    const current = recentlyPlayedGames.value || []

    // If we already have recent games, do not call the API again
    if (current.length > 0) {
        return Promise.resolve(current)
    }

    return get(`${API_URL}recently-games/with-data`, {
        platform: getPlatformForApi(),
        srv: getEnv(),
        client_id: userId,
    })
        .then((res) => {
            if (res.length > 0) {
                const games = mapRecentGames(res)
                recentlyPlayedGames.next(games)
            }
            return recentlyPlayedGames.value
        })
        .catch((error) => {
            NotificationConductor.error(error.toString())
        })
}

const addRecentGame = (gameId, userId = 0) => {
    const getUserId = userId || localStorage.getItem('userId')
    if (getUserId && gameId) {
        post(`${API_URL}recently-games/add`, {
            platform: getPlatformForApi(),
            srv: getEnv(),
            client_id: +getUserId,
            game_id: +gameId,
        })
            .then((res) => {
                if (res.success) {
                    const games = mapRecentGames(res.recently_games)
                    recentlyPlayedGames.next(games)
                }
            })
            .catch((error) => {
                NotificationConductor.error(error.toString())
            })
    }
}

const setJackpots = (games = [], jackpots = []) => {
    let items = games
    items = items.map((item) => {
        jackpots.length &&
            jackpots.forEach((jackpot) => {
                if (item.game_id === jackpot.game_id) {
                    item.jackpot_amount = jackpot.jackpot_amount
                    item.jackpot_amount_formatted =
                        jackpot.jackpot_amount_formatted
                }
            })
        return item
    })
    return items
}
/**
 * @typedef {Object} Popular params
 * @property {string} limit popular games count
 * @property {number} period period of time for getting games by the clicks
 * @property {boolean} [null] excludeHot remove games marked as hot (rod_hot, go_hot)
 * @property {boolean} [null] rodHot add hot games to response, sorts by clicks, adds rodHot to the first place  (exclude_hot и rod_hot can not work together)
 */
const fetchPopularGames = ({
    limit = 100,
    period = 7,
    excludeHot = null,
    goHot = null,
} = {}) => {
    return new Promise((resolve, reject) => {
        const params = {
            platform: getPlatformForApi(),
            app: APP_NAME,
            ...(typeof excludeHot === 'boolean' && { exclude_hot: excludeHot }),
            ...(typeof goHot === 'boolean' && { go_hot: goHot }),
        }
        get(`${CASINOGO_REST_API}games/popular/${period}/${limit}`, params)
            .then((res) => {
                if (res.data) {
                    const popularGames = res.data
                        .map((game) => {
                            if (!Array.isArray(game.features)) {
                                game.features = game.features.split('|')
                            }
                            return game
                        })
                        .sort(
                            (a, b) =>
                                parseFloat(b.go_hot) - parseFloat(a.go_hot) ||
                                a.name.localeCompare(b.name)
                        )

                    resolve(setJackpots(popularGames, jackpotGames.value))
                }
            })
            .catch((e) => {
                reject(e)
            })
    })
}

const setPopularGames = (gameId, userId) => {
    CmsREST.setPopularGames({
        gameId,
        userId,
        app: `casinogo-${!detectMobile() || detectIpad() ? 'web' : 'mobile'}`,
    }).catch((e) => console.error('Cannot set game to popular: ', e))
}

const getUpcomingGames = () => {
    return get(`${CASINOGO_REST_API}games/upcoming`, {
        platform: getPlatformForApi(),
    })
}

const getGameByProvider = (games, gameId) => {
    let game = games.find((g) => g.provider_id === gameId)

    if (game && game.game_id) {
        return game.game_id
    }

    return null
}

const mergeJackpots = (jackpotsInfo, jackpots) => {
    return jackpots.map((item) => {
        let jackpotAmount = item.jackpot_amount

        if (item.subprovider === 'netent' && jackpotsInfo.evolution) {
            const matchEvoGame = jackpotsInfo.evolution.all.find(
                (jackpotEvo) => item.provider_id === jackpotEvo.gameId
            )
            jackpotAmount = (matchEvoGame && matchEvoGame.amount) || 0
        }

        if (item.subprovider === 'isoftbet' && jackpotsInfo.isoftbet) {
            jackpotAmount =
                (jackpotsInfo.isoftbet.levels &&
                    jackpotsInfo.isoftbet.levels[0].amount) ||
                0
        }

        return {
            ...item,
            jackpot_amount: jackpotAmount,
            jackpot_amount_formatted: jackpotAmount
                ? formatDenmarkCurrent(jackpotAmount)
                : item.jackpot_amount_formatted,
        }
    })
}

const prepareLiveCasinoGames = (gamesList = []) => {
    // if (!Array.isArray(gamesList) || gamesList.length === 0) {
    //     // avoid useless call and keep previous liveCasinoData
    //     return
    // }

    post(`${CONTENT_SERVICE_API}live/gamesListInfo`, gamesList)
        .then((res) => {
            if (res && res.data) {
                liveCasinoData.next(res.data)
            } else {
                liveCasinoData.next([])
            }
        })
        .catch((e) => {
            console.error('Error in getLiveCasinoListInfoAdapter:', e)
            liveCasinoData.next([])
        })
}

const withLiveCasinoData = (source$) =>
    combineLatest([source$, liveCasinoData]).pipe(
        map(([gamesData, liveData]) => {
            return liveCasinoDataHandler(gamesData, liveData)
        })
    )

const withLiveCasinoWithMeta = (source$) =>
    combineLatest([source$, liveCasinoData]).pipe(
        map(([data, liveData]) => {
            const games = Array.isArray(data && data.games) ? data.games : []
            const enrichedGames = liveCasinoDataHandler(games, liveData)

            return {
                ...data,
                games: enrichedGames,
            }
        })
    )

const liveCasinoDataHandler = (games = [], liveData = []) => {
    const safeGames = Array.isArray(games) ? games : []
    const safeLiveData = liveCasinoData.value //check liveData

    const liveDataById = new Map()
    safeLiveData.forEach((liveGame) => {
        if (liveGame && liveGame.gameId != null) {
            liveDataById.set(liveGame.gameId, liveGame)
        }
    })

    return safeGames.map((game) => {
        const isLiveInt = game.category === 'liveint' && game.game_id
        const liveCasinoInfo =
            isLiveInt && liveDataById.has(game.game_id)
                ? liveDataById.get(game.game_id)
                : undefined

        return {
            ...game,
            ...(isLiveInt && { liveCas: liveCasinoInfo || {} }),
        }
    })
}

export default {
    getGamesState: () => GamesStatus.asObservable(),
    //getAllGames: () => allGames.asObservable(),
    getGameByProviderId: (gameId) => getGameByProvider(allGames.value, gameId),
    getGamesConfig: () => gamesConfig.asObservable(),
    getMultipleGames: () => multipleGames.asObservable(),
    getNewGames: () => newGames.asObservable(),
    getHiddenGames: () => hiddenGames.asObservable(),
    getBonusGames: () => bonusGames.asObservable(),
    getGameLaunchState: () => isGameLaunched.asObservable(),
    getJackpotGames: () => jackpotGames.asObservable(),
    getFavoriteGames: () => withLiveCasinoData(favoriteGames),
    resetFavoriteGames: () => favoriteGames.next([]),
    getCategorizedGames: () => categorizedGames.asObservable(),
    getCategorizedGamesSubject: () => categorizedGames,
    getGamesCategories: () => gamesCategories.asObservable(),

    fetchGamesCategories: () => {
        get(`${API_URL}categories`, {
            platform: getPlatformForApi(),
            srv: getEnv(),
        })
            .then((res) => {
                fetchPopularGames() // todo remove after update popular games count
                    .then((games) => {
                        const categories = res.data.map((categorie) => {
                            if (categorie.type === 'popular') {
                                categorie.games_count = games.length
                            }
                            return categorie
                        })
                        gamesCategories.next(categories)
                    })
                    .catch((e) => gamesCategories.next(res.data))
            })
            .catch((error) => {
                NotificationConductor.error(error.toString())
            })
    },
    fetchFavorite: (id = null) => {
        const userId = parseInt(localStorage.getItem('userId'))
        if (userId || id) {
            get(`${CASINOGO_REST_API}clients/${userId || id}/games`, {
                platform: getPlatformForApi(),
                srv: getEnv(),
            })
                .then((res) => {
                    if (res.error) {
                        NotificationConductor.error(res.error)
                    } else {
                        const preparedGames = setJackpots(
                            res.data,
                            jackpotGames.value
                        ).filter((g) => g.go_hide === false)

                        favoriteGames.next(preparedGames)
                    }
                })
                .catch((error) => {
                    NotificationConductor.error(error.toString())
                })
        }
    },
    fetchCombinedJackpots: () => {
        return Promise.allSettled([
            get(`${CASINOGO_REST_API}categories/jackpots/games`, {
                srv: getEnv(),
                platform: getPlatformForApi(),
            }),
            get(`${CONTENT_SERVICE_API}jackpot/all`),
        ])
            .then((results) => {
                const [jackpotsResult, jackpotsInfo] = results

                if (jackpotsResult.status !== 'fulfilled') {
                    throw new Error('Failed to fetch jackpot games')
                }

                const jackpotGamesData = jackpotsResult.value.data

                const mergedData =
                    jackpotsInfo.status === 'fulfilled'
                        ? mergeJackpots(
                              jackpotsInfo.value.data,
                              jackpotGamesData
                          )
                        : jackpotGamesData

                jackpotGames.next(mergedData)
            })
            .catch((err) => {
                NotificationConductor.error(err.toString())
            })
    },
    fetchGames: (endpoint = '') => {
        GamesStatus.next({ pending: true, success: false, error: '' })
        const fetchEndpoint = endpoint ? '/' + endpoint : ''
        fetchGames(fetchEndpoint)
            .then((res) => {
                GamesStatus.next({ pending: false, success: true, error: '' })
                const preparedGames = setJackpots(res.data, jackpotGames.value)
                setGamesByEndpoint(endpoint, preparedGames)
            })
            .catch((err) => {
                NotificationConductor.error(err)
                GamesStatus.next({ pending: false, success: false, error: err })
            })
    },
    fetchGamesByCategory: (category) => {
        GamesStatus.next({ pending: true, success: false, error: '' })
        get(`${API_URL}categories/${category}/games`, {
            srv: getEnv(),
            platform: getPlatformForApi(),
        })
            .then((res) => {
                GamesStatus.next({ pending: false, success: true, error: '' })
                const preparedGames = setJackpots(res.data, jackpotGames.value)
                categorizedGames.next(preparedGames)
            })
            .catch((err) => {
                NotificationConductor.error(err.toString())
                GamesStatus.next({ pending: false, success: false, error: err })
            })
    },

    fetchLiveCasino: (category = '', pageNumber = 1, pageSize = 10) => {
        get(API_URL + 'categories/liveint/games', {
            platform: getPlatformForApi(),
            srv: getEnv(),
            app: APP_NAME,
            'page[size]': pageSize,
            'page[number]': pageNumber,
            sort_clicks: true,
            ...(category && { subcat: category }),
        })
            .then((res) => {
                const responseData = res.data || []

                let games = responseData.filter((g) => g.go_hide === false)

                const result = {
                    meta: res.meta || { total: 0, last_page: 1 },
                    games,
                    gameIds: games.reduce((acc, game) => {
                        if (game.game_id) {
                            acc.push(game.game_id)
                        }
                        return acc
                    }, []),
                }

                liveCasinoGames.next(result)
            })
            .catch((error) => {
                console.error(
                    'Error fetching live casino games:',
                    error.toString()
                )
                // Return empty data structure with defaults in case of error
                liveCasinoGames.next({
                    meta: { total: 0, last_page: 1 },
                    games: [],
                    gameIds: [],
                })
            })
    },
    getLiveCasinoGames: () => withLiveCasinoWithMeta(liveCasinoGames),
    enrichGamesArrayWithLiveCasinoData: (games) => liveCasinoDataHandler(games), //for object
    setLiveCasinoData: (withInterval = true) => {
        prepareLiveCasinoGames()

        if (withInterval) {
            // Clear any existing interval / timeout before starting a new one
            if (intervalLiveCasino) {
                clearInterval(intervalLiveCasino)
                intervalLiveCasino = null
            }
            if (intervalLiveCasinoStopTimeout) {
                clearTimeout(intervalLiveCasinoStopTimeout)
                intervalLiveCasinoStopTimeout = null
            }

            // Poll every 30 seconds
            intervalLiveCasino = setInterval(prepareLiveCasinoGames, 30000)

            // Stop polling after 15 minutes
            intervalLiveCasinoStopTimeout = setTimeout(() => {
                if (intervalLiveCasino) {
                    clearInterval(intervalLiveCasino)
                    intervalLiveCasino = null
                }
                intervalLiveCasinoStopTimeout = null
            }, 15 * 60 * 1000)
        }
    },
    fetchGameById: (id) => {
        return get(`${CASINOGO_REST_API}games/${id}`, {
            srv: getEnv(),
            platform: getPlatformForApi(),
        }).catch((err) => {
            console.error(err)
        })
    },

    setGameLaunchState: (state) => isGameLaunched.next(state),

    setMultipleGames: (game) =>
        multipleGames.next(getMultipleGameFromTheStore(game)),

    removeMultipleGames: (key) =>
        multipleGames.next(removeMultipleGameFromTheStore(key)),

    updateMultipleGames: (key, game) =>
        multipleGames.next(updateMultipleGameInTheStore(key, game)),

    searchGames: (searchString) =>
        get(
            CASINOGO_REST_API +
                `games/smart-search?srv=${getEnv()}&platform=${getPlatformForApi()}&` +
                searchString
        ),
    filterGames: (param, value, showOnPage = 30, pageNumber = 1) =>
        get(API_URL + `games/smart-search`, {
            platform: getPlatformForApi(),
            srv: getEnv(),
            app: APP_NAME,
            [param]: value,
            'page[size]': showOnPage,
            'page[number]': pageNumber,
        }),
    fetchProvidersGames: () => {
        get(`${CASINOGO_REST_API}providers`, {
            srv: getEnv(),
            platform: getPlatformForApi(),
            include_hidden: getEnvWithBeta() === 'test',
        }).then((res) => {
            if (res.data) {
                const mappedProvidersConfigs = res.data.map((provider) => {
                    let item = providersData.find(
                        (providerItem) => providerItem.name === provider.name
                    )
                    return provider ? { ...provider, ...item } : item
                })
                const filterGames = mappedProvidersConfigs.filter(
                    (provider) => provider.name !== 'gdm' // exclude gdm because it's combined with SG
                )
                providersGames.next(filterGames)
            }
        })
    },
    getProvidersGames: () => providersGames,
    getGameLaunchUrl,
    gameLike,
    gameUnLike,
    sortGames,
    getIterationLength,
    LaunchGame,
    launchPendingGame,
    checkLoginBeforeStart,
    setRecentlyPlayedGames: (userId) => setRecentGames(userId),
    getRecentlyPlayedGames: () => withLiveCasinoData(recentlyPlayedGames),
    pushGameToRecentlyPlayed: (gameId, userId) => addRecentGame(gameId, userId),
    prepareJackpotsGame: (games) => setJackpots(games, jackpotGames.value),
    setMinimizedGamePosition: (gameData) => {
        const prevData = minimizedGamesData.value
        minimizedGamesData.next({
            ...prevData,
            gamesPosition: {
                ...prevData.gamesPosition,
                ...gameData,
            },
        })
    },
    setMinimizedGames: (game, resetPrevGames = false) => {
        const prevData = minimizedGamesData.value
        if (prevData && prevData.games && !resetPrevGames) {
            if (
                !prevData.games.some(
                    (prevGame) => prevGame.game_id === game.game_id
                ) &&
                Object.values(game).length
            ) {
                minimizedGamesData.next({
                    ...prevData,
                    games: [...prevData.games, game], // todo here is the issue
                })
            }
        } else {
            minimizedGamesData.next({
                ...prevData,
                games: [game],
            })
        }
    },
    setMinimizeStates: (state) =>
        minimizedGamesData.next({ ...minimizedGamesData.value, ...state }),
    getMinimizedGame: () => minimizedGamesData.asObservable(),
    removeMinimizedGame: (gameId = null) => {
        let minimizedGamesStore = minimizedGamesData.value.games
        const key = minimizedGamesStore.findIndex(
            (game) => game.game_id === gameId
        )
        if (minimizedGamesStore.length) {
            minimizedGamesStore[key] = {}
            minimizedGamesData.next({
                ...minimizedGamesData.value,
                games: [...minimizedGamesStore],
            })
        }

        const gamesPosition = minimizedGamesData.value.gamesPosition
        if (gamesPosition[gameId]) {
            delete gamesPosition[gameId]
            minimizedGamesData.next({
                ...minimizedGamesData.value,
                gamesPosition: {
                    ...gamesPosition,
                },
            })
        }
    },
    cleanMinimizedData: () => minimizedGamesData.next({}),
    getEndGame: () => get(`${endGameUrl.value}`),
    fetchPopularGames,
    setPopularGames,
    getUpcomingGames,
    //getAllProvidersGames,
    fetchRecommendedGames: (id = null) => {
        const userId = parseInt(localStorage.getItem('userId'))
        if (userId || id) {
            get(`${CONTENT_SERVICE_API}user/recommendations`, {
                userId: userId || id,
                platform: getPlatformForApi(),
                site: 'go',
            })
                .then((res) => {
                    if (res.error) {
                        NotificationConductor.error(res.error)
                    } else {
                        const fillInWithJackpots = setJackpots(res.data)
                        recommendedGames.next(fillInWithJackpots)
                    }
                })
                .catch((error) => {
                    console.error('ERROR fetchRecommendedGames', error)
                    NotificationConductor.error(error.toString())
                })
        }
    },
    getRecommendedGames: () => withLiveCasinoData(recommendedGames),
}
